module.exports = __webpack_public_path__ + "static/media/Screen3_right.7f0d016e.png";